import * as React from 'react';
const SvgMediaPlay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M6.2 19.611c-.2-.26-.2-.73-.2-1.66v-11.9c0-.93 0-1.4.2-1.66.07-.1.16-.18.26-.24.13-.08.29-.14.46-.15.33-.02.73.23 1.52.74l9.335 5.95c.69.44 1.03.66 1.15.94a1 1 0 0 1 0 .76c-.12.28-.46.5-1.15.94l-9.334 5.93c-.79.51-1.19.76-1.52.74a.97.97 0 0 1-.72-.39"
    />
  </svg>
);
export default SvgMediaPlay;
